import { render } from "./JournalFilter.vue?vue&type=template&id=cf3ffb2e&scoped=true"
import script from "./JournalFilter.vue?vue&type=script&lang=js"
export * from "./JournalFilter.vue?vue&type=script&lang=js"

import "./JournalFilter.vue?vue&type=style&index=0&id=cf3ffb2e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3ffb2e"]])

export default __exports__